import StatutoryComponents from "../Statutary/StatutoryComponents";

export default function EsiSettings() {
  return <StatutoryComponents forcedTab="esi" />;
}
